module.exports = __webpack_public_path__ + "img/imgAi1.0a718bcf.jpeg";